export const clickOutside = { // eslint-disable-line
  bind(el, binding, vnode) {
    el.onClickOutside = (event) => {
      if (!el.contains(event.target)) {
        vnode.context[binding.expression](event);
      }
    };

    document.body.addEventListener('click', el.onClickOutside);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.onClickOutside);

    delete el.onClickOutside;
  },
};
